import { useFieldArray, useFormContext } from "react-hook-form";

import { FormValues } from ".";
import { DataTable } from "./add-tasks-table/data-table";
import { columns } from "./add-tasks-table/columns";

export const AddTasks = ({
  assignees,
}: {
  assignees: {
    value: string;
    label: string;
  }[];
}) => {
  const form = useFormContext<FormValues>();

  const {
    fields: tasksFields,
    append: appendTask,
    remove: removeTask,
    update: updateTask,
  } = useFieldArray({
    name: "tasks",
    control: form.control,
  });

  return (
    <div className="flex flex-col">
      <h2 className="text-lg font-medium">Subtasks</h2>

      <DataTable
        assignees={assignees}
        columns={columns}
        data={tasksFields}
        removeSubTaskRow={removeTask}
        appendSubTaskRow={appendTask}
        updateSubTaskRow={updateTask}
      />
    </div>
  );
};
